<template>
  <!-- vant 清空图标 -->
  <van-icon ref="clear" name="close" @click.stop="clearFieldModel" />
</template>
<script setup>
import { ref, nextTick } from 'vue';
import { findParentByComponentName } from '@/utils/util';
const clear = ref(null);

const clearFieldModel = () => {
  const parentWidget = findParentByComponentName(clear.value, 'FieldWidget');
  if (parentWidget) {
    if (Array.isArray(parentWidget.fieldModel)) {
      parentWidget.fieldModel.splice(0);
    } else {
      parentWidget.fieldModel = null;
    }
    parentWidget.syncUpdateFormModel(parentWidget.fieldModel);
    parentWidget.handleChangeEvent(parentWidget.fieldModel);
  }
};
</script>
